// index.js
// Component for Report view

// Imports
import React from 'react';
import { Flex } from 'reflexbox';
import Report from '../../data/Report';
import IndividualReport from './IndividualReport';
import BuyReport from './BuyReport';
import PeriodBuyReport from './PeriodBuyReport';
import OrderListReport from './OrderListReport';
import ClientReport from './ClientReport';
import ClientDigestReport from './ClientDigestReport';
import AllIndividualReport from './AllIndividualReport';
import PriceReport from './PriceReport';
import PropTypes from 'prop-types';

// Component Class
// Shows Report View
class ReportView extends React.Component {
  // Builds a Report handler
  buildReport = () => {
    return new Report(this.props.clients, this.props.products, this.props.orders);
  }

  // Renders Component
  render() {
    var report = this.buildReport();
    return (
      <Flex wrap justify='left' w={1} p={2}>
        <IndividualReport report={report} {...this.props} />
        <BuyReport report={report} {...this.props} />
        <PeriodBuyReport report={report} {...this.props} />
        <OrderListReport report={report} {...this.props} />
        <ClientReport report={report} {...this.props} />
        <ClientDigestReport report={report} {...this.props} />
        <AllIndividualReport report={report} {...this.props} />
        <PriceReport report={report} {...this.props} />
      </Flex>
    );
  }
}

// Required Properties
ReportView.propTypes = {
  clients: PropTypes.object.isRequired,
  products: PropTypes.object.isRequired,
  orders: PropTypes.object.isRequired,
}

// Exports
export default ReportView;


// WEBPACK FOOTER //
// ./src/components/ReportView/index.js